export default class CurrentVersion {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        currentVersionRetrieve(id: ${id}) {
          id
          app
          dateTimeEnd
          version
          changeLog
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.currentVersionRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        currentVersionList{
          results{
            id
            app
            dateTimeEnd
            version
            changeLog
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.currentVersionList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deleteCurrentVersion ($id: ID!){
          deleteCurrentVersion(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deleteCurrentVersion.ok;
  }

  static async create(axios, app, dateTimeEnd, version, changeLog) {

    const response = await axios.post(
      '/graphql/',
      `mutation {
        createCurrentVersion(newCurrentversion:{
          app: "${app}",
          dateTimeEnd: "${dateTimeEnd}",
          version: "${version}",
          changeLog: "${changeLog}",
        }){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createCurrentVersion.ok;
  }

  static async edit(axios, id, app, dateTimeEnd, version, changeLog) {

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateCurrentVersion(newCurrentversion:{
          id: "${id}",
          app: "${app}",
          dateTimeEnd: "${dateTimeEnd}",
          version: "${version}",
          changeLog: "${changeLog}",
        }){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateCurrentVersion.ok;
  }
}